import React from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import Image from 'src/elements/image/image';
import LinkBranded from 'src/elements/links/Link.branded';
import Heading from 'src/elements/typography/heading';
import {
  InterviewProcessConfettiWrapper,
  InterviewProcessContainer,
  InterviewProcessIconography,
  InterviewProcessIconographyEntry,
  InterviewProcessImage,
  InterviewProcessTitle
} from './interviewProcess.styles';

interface InterviewProcessProps {
  title: string;
  buttonText: string;
  steps: {
    name: string;
    image: IGatsbyImageData;
  }[]
}

const InterviewProcess = ({ title, steps, buttonText }: InterviewProcessProps): JSX.Element => {
  return (
    <InterviewProcessConfettiWrapper>
      <InterviewProcessContainer>
        <InterviewProcessTitle>
          <FadeInAnimationWrapper>
            <Heading
              text={title}
              size="2.5em"
              sizeMd="1.5em"
              align="center"
            />
          </FadeInAnimationWrapper>
          <InterviewProcessIconography>
            {
              steps.map((coreValue, index) => (
                <InterviewProcessIconographyEntry key={index}>
                  <InterviewProcessImage>
                    <Image childImageSharp={coreValue.image} alt={coreValue.name} />
                  </InterviewProcessImage>
                  <Heading
                    text={coreValue.name}
                    size="1.35em"
                    sizeMd="1em"
                    align="center"
                    weight="normal"
                  />
                </InterviewProcessIconographyEntry>
              ))
            }
          </InterviewProcessIconography>
          <LinkBranded
            text={buttonText}
            url="#jobs"
            smooth={true}
            justify="center"
            size="1em" sizeMd="1em"/>
        </InterviewProcessTitle>
      </InterviewProcessContainer>
    </InterviewProcessConfettiWrapper>

  )
}

export default InterviewProcess;
